import { Play, Square } from "lucide-react";

const isMac = typeof navigator !== "undefined" && /Mac|iPhone|iPad/.test(navigator.platform);

/** Run, or Stop while a run is in progress (ADR-0020). */
export function RunButton({
  running,
  disabled,
  onRun,
  onStop,
}: {
  running: boolean;
  disabled: boolean;
  onRun: () => void;
  onStop: () => void;
}) {
  const shortcut = isMac ? "⌘↵" : "Ctrl+↵";
  return running ? (
    <button
      type="button"
      onClick={onStop}
      data-testid="stop"
      className="flex items-center gap-1.5 rounded bg-red px-3 py-1 font-medium text-bg hover:opacity-90 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red"
    >
      <Square size={14} aria-hidden /> Stop
    </button>
  ) : (
    <button
      type="button"
      onClick={onRun}
      disabled={disabled}
      title={`Run (${shortcut})`}
      data-testid="run"
      className="flex items-center gap-1.5 rounded bg-blue px-3 py-1 font-medium text-bg hover:opacity-90 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue disabled:opacity-50"
    >
      <Play size={14} aria-hidden /> Run
      <kbd className="font-mono text-xs opacity-80">{shortcut}</kbd>
    </button>
  );
}
